const cards = document.querySelectorAll('.custom-feature-columns-section .custom-columns-wrapper .grid__item');

cards.forEach(card =>card.addEventListener('click', function(){
    const hasMoreInfo = document.querySelector('.more-info');
    this.classList.toggle('more-info')

    // Comment off if you want to show hidden card more than one
    // if(hasMoreInfo !== null){
    //     hasMoreInfo.classList.remove('more-info')
    // }

}))

// const cards_no_slider = document.querySelectorAll('.custom-feature-columns-no-slider .custom-columns-no-slider-wrapper .grid__item');

// cards_no_slider.forEach(card =>card.addEventListener('click', function(){
//     // const hasMoreInfo = document.querySelector('.more-info');
//     this.classList.toggle('more-info')

//     // Comment off if you want to show hidden card more than one
//     // if(hasMoreInfo !== null){
//     //     hasMoreInfo.classList.remove('more-info')
//     // }

// }))


const cards_no_slider = document.querySelectorAll('.custom-feature-columns-no-slider .custom-columns-no-slider-wrapper .grid__item');

cards_no_slider.forEach(card => {card.addEventListener('click', function() {
  // const hasMoreInfo = document.querySelector('.more-info');
    this.classList.toggle('more-info');

     // Comment off if you want to show hidden card more than one
    // if(hasMoreInfo !== null){
    //     hasMoreInfo.classList.remove('more-info')
    // }

    // Toggle brand-card-btn-wrapper visibility
    const brandCardBtnWrapper = this.querySelector('.brand-card-btn-wrapper');
    if (brandCardBtnWrapper) {
      brandCardBtnWrapper.classList.toggle('hidden');
    }

    // Toggle hidden description visibility
    const brandCardDesc = this.querySelector('.body-m');
    if(brandCardDesc){
      brandCardDesc.classList.toggle('visible');
    }
  });
});






